module.exports = __webpack_public_path__ + "static/goodrich-mobile-69f353f0e804ba20ad3aa7024b88da32.jpg";